import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'
import { type FC, useEffect, useRef } from 'react'
import { configClient } from '@egw/config'
import { type Config } from '../../config/config'

const log = new Logger('DocV')

interface ConsentScreenProps {
  session: { token: string }
  onAccept: () => void
  onReject?: (error?: any) => void
}

export const ConsentScreen: FC<ConsentScreenProps> = ({ session, onAccept }) => {
  const config = configClient.getConfig() as Config

  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }

    log.info('ConsentScreen: Rendering combined consent')

    getIncodeClient().renderCombinedConsent(containerRef.current, {
      token: session,
      onSuccess: () => {
        log.info('ConsentScreen: Consent accepted')
        onAccept()
      },
      consentId: config.incode.consentId,
    })

    isMounted.current = true
  }, [session, onAccept])

  return <div ref={containerRef} className="w-full" style={{ background: '#fff !important' }} />
}
